export const urls = {
    baseApiUrl: "https://zkilltrackerapi.mostlycapstable.com",
    websiteUrl: "https://zkilltracker.mostlycapstable.com",
};
